module.exports = __webpack_public_path__ + "static/media/DICA.54525c4b.png";